module.exports = __webpack_public_path__ + "img/wordle-3.e698263d.svg";